import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { AddToFavBlock } from '../AddToFavBlock/AddToFavBlock.jsx';
import { AddToCartBlock } from '../AddToCartBlock/AddToCartBlock.jsx';
import { createInnerHtml } from '../../../../../helpers/helpers';

const _SubstitutionSectionHeader = (props) => {
  const { parentSkuID, substStore, labelsStore, type, optionsStore, endOfSale, isLabelRef } = props;
  const headerClassList = `subst-section__header subst-section__header--${type}`;
  const titleHtml = substStore && substStore.title
    ? substStore.title
    : getReplacedTitle(labelsStore, type, parentSkuID);
  const addToBlock = optionsStore.isCartTransferAvailable
    ? (<AddToCartBlock substStore={substStore} isGroup />)
    : (<AddToFavBlock substStore={substStore} isGroup />);

  // TODO: re-develop with 'showSubstitutionHeader' flag or || operator

  return (
    <div className={headerClassList}>
      { (isLabelRef || endOfSale) && <span className="subst-section__header-title" dangerouslySetInnerHTML={createInnerHtml(titleHtml)} /> }
      {type === 'group' && addToBlock}
    </div>
  );
};

const getTitleTemplate = (labelsObj, titleType) => {
  const type = titleType.toLowerCase();
  if (type === 'range')
    return labelsObj.substSectionRangeTitle;
  return labelsObj.substSectionAbsentTitle;
};

const getReplacedTitle = (labelsObj, sectionType, replacement) => {
  const titleTemplate = getTitleTemplate(labelsObj, sectionType);
  const pattern = /#obsolete product ID#|#commercial-reference#/gi;

  return titleTemplate.replace(pattern, replacement);
};

_SubstitutionSectionHeader.propTypes = {
  parentSkuID: propTypes.string.isRequired,

  labelsStore: propTypes.shape({
    substSectionRangeTitle: propTypes.string.isRequired,
    substSectionAbsentTitle: propTypes.string.isRequired
  }).isRequired,

  type: propTypes.string,
  endOfSale: propTypes.bool,
  isLabelRef: propTypes.bool,

  substStore: propTypes.object,

  optionsStore: propTypes.shape({
    isCartTransferAvailable: propTypes.bool.isRequired
  }).isRequired
};

_SubstitutionSectionHeader.defaultProps = {
  type: 'absent'
};

export const SubstitutionSectionHeader = inject('labelsStore', 'optionsStore')(observer(_SubstitutionSectionHeader));
